/**
 * Laravel API origin.
 * - Development: use "" so requests go to the Vue dev server origin; vue.config.js proxies /api and /sanctum to Laravel (cookies stay same-site).
 * - Production: set VUE_APP_API_ORIGIN to your API base (e.g. https://api.example.com) and configure CORS + SANCTUM_STATEFUL_DOMAINS on Laravel.
 */
const API_ORIGIN =
  process.env.VUE_APP_API_ORIGIN ||
  (process.env.NODE_ENV === "development" ? "" : "http://localhost:8000");

/** Absolute API origin for building storage URLs when XHR uses same-origin proxy (empty API_ORIGIN). */
export const API_ASSET_ORIGIN =
  API_ORIGIN ||
  process.env.VUE_APP_API_ASSET_ORIGIN ||
  (process.env.NODE_ENV === "development" ? "http://localhost:8000" : "");

/**
 * Frontend app origin used for sibling tools served from the same host,
 * such as /task-management-tool.
 */
export const APP_ORIGIN =
  process.env.VUE_APP_APP_ORIGIN ||
  (typeof window !== "undefined" ? window.location.origin : "");

const DEFAULT_TASK_TOOL_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8081/task-management-tool/#/task"
    : APP_ORIGIN
    ? `${APP_ORIGIN}/task-management-tool/#/task`
    : "";

/**
 * Full task tool URL and origin.
 * Override with VUE_APP_TASK_TOOL_URL / VUE_APP_TASK_TOOL_ORIGIN when the
 * task app is hosted on a separate domain.
 */
export const TASK_TOOL_URL =
  process.env.VUE_APP_TASK_TOOL_URL || DEFAULT_TASK_TOOL_URL;

export const TASK_TOOL_ORIGIN =
  process.env.VUE_APP_TASK_TOOL_ORIGIN ||
  (() => {
    try {
      return TASK_TOOL_URL ? new URL(TASK_TOOL_URL).origin : APP_ORIGIN;
    } catch {
      return APP_ORIGIN;
    }
  })();

export default API_ORIGIN;
